import dayjs from 'dayjs'

export default (date = '', format = '') => {
    return dayjs(date?.replace(/Z/g, '')).format(format)
}
